import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { apiErrorDiagnosticsMiddleware } from '~/store/middlewares/apiErrorDiagnostics/apiErrorDiagnostics.middleware';
import { rtkErrorNotifierMiddleware } from '~/store/middlewares/rtkErrorNotifier/rtkErrorNotifier.middleware';
import { sentryNotifierMiddleware } from '~/store/middlewares/sentryNotifier/sentryNotifier.middleware';
import { myPagesUnauthenticatedBaseApi } from './apis/endpoints/_baseApi/myPages.unauthenticated.base.api';
import { onboardingUnauthenticatedApi } from './apis/endpoints/_baseApi/onboarding.unauthenticated.base.api';
import { onboardingApi } from './apis/endpoints/onboardingApi/onboarding.api';
import { openBankingApi } from './apis/endpoints/openBankingApi/openBanking.api';
import { clientAssessmentApi } from './apis/endpoints/clientAssessmentApi/clientAssessment.api';
import { listenerMiddleware } from './middlewares/listener.middleware';
import rootReducer from './reducers/rootReducer';
import { userManagementApi } from './apis/endpoints/userManagementApi/userManagement.api';

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

export const setupStore = (preloadedState?: Partial<RootState>) => {
  if (preloadedState?.intl?.market) {
    window.__QRED_MARKET__ = preloadedState.intl.market;
  }

  return configureStore({
    reducer: rootReducer,
    preloadedState,
    enhancers: [sentryReduxEnhancer],
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).concat(
        listenerMiddleware.middleware,
        myPagesUnauthenticatedBaseApi.middleware,
        onboardingUnauthenticatedApi.middleware,
        openBankingApi.middleware,
        onboardingApi.middleware,
        clientAssessmentApi.middleware,
        userManagementApi.middleware,
        apiErrorDiagnosticsMiddleware,
        sentryNotifierMiddleware,
        rtkErrorNotifierMiddleware
      ),
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export type GetStateFunc = () => RootState;
